module.exports = __webpack_public_path__ + "img/6.3fd5225b.jpeg";